import { activityURL } from './activity-api';
export var activityCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, filterByValue = _a.filterByValue, nextCursor = _a.nextCursor;
    return [
        activityURL,
        { accountId: accountId, accountIdType: accountIdType, filterByValue: filterByValue, nextCursor: nextCursor }
    ];
};
//# sourceMappingURL=activity-cache-keys.js.map